import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_quote",
  "use": "icon_quote-usage",
  "viewBox": "0 0 65 58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 65 58\" id=\"icon_quote\"><path fill=\"currentColor\" d=\"M64.224 13.248c-6.696 1.728-11.232 7.344-11.448 16.848H64.44v27.216H38.736V29.88c0-16.2 10.584-26.568 25.488-29.376006V13.248ZM.936001 57.312V29.88C.936001 13.68 11.52 3.312 26.424.503994V13.248c-6.696 1.728-11.232 7.344-11.448 16.848H26.64v27.216H.936001Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol